import firebase from 'firebase'
import 'firebase/firestore'

// firebase init
const config = {
  apiKey: "AIzaSyCOSRdXbhigWQ2N3G3T0Etga7HMxcxhrZk",
  authDomain: "ccs-web-d6ae1.firebaseapp.com",
  databaseURL: "https://ccs-web-d6ae1.firebaseio.com",
  projectId: "ccs-web-d6ae1",
  storageBucket: "ccs-web-d6ae1.appspot.com",
  messagingSenderId: "349082511018"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const storage = firebase.storage()


// date issue fix according to firebase
const settings = {
  timestampsInSnapshots: true
}
db.settings(settings)

// firebase storage refs
const storageRef = storage.ref()

const batch = db.batch()

// firebase collections
const usersCollection = db.collection('users')
const testOrgCardsIssuedCollection = db.collection('orgCardsIssued')
const orgCardOrdersCollection = db.collection('orgCardOrders')
const newOrgCardOrdersCollection = db.collection('newOrgCardOrders')
const orgCardTemplateCollection = db.collection('orgCardTemplate')
const testOrgCardOrdersCollection = db.collection('testOrgCardOrders')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    testOrgCardsIssuedCollection,
    orgCardOrdersCollection,
    newOrgCardOrdersCollection,
    testOrgCardOrdersCollection,
    orgCardTemplateCollection,
    batch,
    storageRef,
    storage
}
